module.exports = __webpack_public_path__ + "static/img/advantage.eb4f0a7b.png";